// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"87bdef22","360":"2944656e","415":"fa01635b","445":"a51e664b","536":"08cbc599","827":"295b5e6f","994":"834dcbb3"}[chunkId] + ".chunk.css";
};